import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const { error: err } = await resetPassword(email);
    setLoading(false);
    if (err) {
      setError(err.message);
    } else {
      setDone(true);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logo} onClick={() => navigate('/')}>
          <img src="/logo-frontup.png" style={{width:32,height:32,borderRadius:8,objectFit:'cover'}} alt="FrontUp" />
          <span style={styles.logoName}>FrontUp</span>
        </div>

        {done ? (
          <>
            <div style={styles.successIcon}>
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#fff" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <h1 style={{...styles.title, marginTop: 20}}>Mail gesendet</h1>
            <p style={{...styles.sub, marginBottom: 28}}>
              Wir haben einen Reset-Link an <strong style={{color:'#111'}}>{email}</strong> gesendet. Überprüfe auch deinen Spam-Ordner.
            </p>
            <button onClick={() => navigate('/login')} style={styles.submitBtn}>Zurück zum Login</button>
          </>
        ) : (
          <>
            <h1 style={styles.title}>Passwort vergessen</h1>
            <p style={styles.sub}>Gib deine E-Mail ein. Wir senden dir einen Link zum Zurücksetzen.</p>

            <form onSubmit={handleSubmit} style={styles.form}>
              <div style={styles.field}>
                <label style={styles.label}>E-Mail</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="deine@email.de"
                  required
                  style={styles.input}
                />
              </div>

              {error && <div style={styles.error}>{error}</div>}

              <button type="submit" disabled={loading} style={styles.submitBtn}>
                {loading ? 'Senden...' : 'Reset-Link senden'}
              </button>
            </form>

            <p style={styles.switchText}>
              <span style={styles.switchLink} onClick={() => navigate('/login')}>← Zurück zum Login</span>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f7f7f7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  card: {
    background: '#fff',
    border: '1.5px solid #e5e5e5',
    borderRadius: 20,
    padding: '48px 44px',
    width: '100%',
    maxWidth: 440,
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 32,
    cursor: 'pointer',
  },
  logoName: {
    fontSize: 18,
    fontWeight: 800,
    letterSpacing: '-.5px',
    color: '#111',
  },
  successIcon: {
    width: 48,
    height: 48,
    background: '#111',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 28,
    fontWeight: 800,
    letterSpacing: '-1px',
    color: '#111',
    marginBottom: 6,
  },
  sub: {
    fontSize: 15,
    color: '#888',
    lineHeight: 1.6,
    marginBottom: 32,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: 7,
  },
  label: {
    fontSize: 13,
    fontWeight: 600,
    color: '#111',
  },
  input: {
    padding: '12px 14px',
    border: '1.5px solid #e5e5e5',
    borderRadius: 10,
    fontSize: 15,
    fontFamily: 'inherit',
    color: '#111',
    outline: 'none',
    width: '100%',
    background: '#fff',
    transition: 'border-color .15s',
  },
  error: {
    background: '#fff5f5',
    border: '1px solid #fecaca',
    borderRadius: 8,
    padding: '10px 14px',
    fontSize: 13,
    color: '#dc2626',
  },
  submitBtn: {
    padding: '14px',
    background: '#111',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 700,
    fontFamily: 'inherit',
    cursor: 'pointer',
    transition: 'background .15s',
  },
  switchText: {
    textAlign: 'center',
    fontSize: 14,
    color: '#888',
    marginTop: 24,
  },
  switchLink: {
    color: '#555',
    fontWeight: 600,
    cursor: 'pointer',
  },
};

export default ForgotPasswordPage;
